import React, { useRef, useEffect } from "react";
import { Bold, Italic, List, ListOrdered, Underline } from "lucide-react";

export const RichTextEditor = ({ value, onChange, placeholder = "", testid = "rich-editor" }) => {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const incoming = value || "";
    // Só reescreve o DOM em mudanças externas (carregar modelo/editar/limpar),
    // sem atrapalhar a digitação (não mexe enquanto o editor está focado).
    if (el.innerHTML !== incoming && document.activeElement !== el) {
      el.innerHTML = incoming;
    }
  }, [value]);

  const emit = () => onChange(ref.current?.innerHTML === "<br>" ? "" : (ref.current?.innerHTML || ""));
  const exec = (cmd) => { document.execCommand(cmd, false, null); ref.current?.focus(); emit(); };

  const Btn = ({ cmd, icon: Icon, label }) => (
    <button
      type="button"
      onMouseDown={(e) => { e.preventDefault(); exec(cmd); }}
      className="p-1.5 rounded hover:bg-slate-200 text-slate-600 transition-colors"
      title={label}
      data-testid={`${testid}-${cmd}`}
    >
      <Icon className="w-4 h-4" />
    </button>
  );

  return (
    <div className="border border-slate-200 rounded-lg overflow-hidden focus-within:ring-2 focus-within:ring-blue-200">
      <div className="flex items-center gap-0.5 border-b border-slate-100 bg-slate-50 px-1.5 py-1">
        <Btn cmd="bold" icon={Bold} label="Negrito" />
        <Btn cmd="italic" icon={Italic} label="Itálico" />
        <Btn cmd="underline" icon={Underline} label="Sublinhado" />
        <span className="w-px h-5 bg-slate-200 mx-1" />
        <Btn cmd="insertUnorderedList" icon={List} label="Lista com marcadores" />
        <Btn cmd="insertOrderedList" icon={ListOrdered} label="Lista numerada" />
      </div>
      <div
        ref={ref}
        contentEditable
        suppressContentEditableWarning
        onInput={emit}
        onBlur={emit}
        className="rich-editable min-h-[120px] px-3 py-2 text-sm text-slate-700 leading-relaxed focus:outline-none"
        data-placeholder={placeholder}
        data-testid={testid}
      />
    </div>
  );
};
